import { useSelector } from 'react-redux';

export const useGetPosition = ({ instanceId, stockCode }) => (
  useSelector((state) => state.positions[instanceId]?.data.mergedPositions[stockCode])
);

export default null;
